module.exports = __webpack_public_path__ + "img/0Q3A6289_L_Foamcore.fe0b53a2.jpg";